import {
  IDateObjectStyleConfiguration,
  IBackgroundColorConfiguration,
  IBorderColorConfiguration,
  IObjectColorConfiguration,
  IEnableConfiguration,
} from "../../../../domain/configuration";
import {
  PaintStyle,
  TextStyle,
} from "../../../../domain/drawing";
import {
  DateItem,
} from "../../../../domain/document/items";
import {
  DateInputMethodKinds,
} from "../../../../domain/document/inputMethodKinds";
import { DateInputMethodOptionKinds } from "../../../../domain/document/inputMethodOptionKinds";
import { AbstractTextObjectStyleReader } from "./AbstractTextObjectStyleReader";
import { FixedColorSource } from ".";

export class DateObjectStyleReader extends AbstractTextObjectStyleReader<DateItem> {
  constructor(private readonly _configuration: IDateObjectStyleConfiguration) {
    super();
  }

  protected readSpecifiedPaintStyle(source: DateItem, shouldInputFree: boolean): PaintStyle {
    return source.paintStyleOnEditing;
  }

  protected readBackgroundColorConfiguration(source: DateItem, shouldInputFree: boolean): IBackgroundColorConfiguration {
    return this.readObjectStyleConfiguration(source, shouldInputFree);
  }

  protected readBorderColorConfiguration(source: DateItem, shouldInputFree: boolean): IBorderColorConfiguration {
    return this.readObjectStyleConfiguration(source, shouldInputFree);
  }

  private readObjectStyleConfiguration(source: DateItem, shouldInputFree: boolean): IObjectColorConfiguration {
    if (source.injectedRule && source.injectedRule.isEditDisabled) {
      return FixedColorSource.uneditable;
    }
    if ((source.isFreeInputable && shouldInputFree)) {
      return this._configuration.default;
    }
    switch (source.inputMethodKind) {
      case DateInputMethodKinds.Calendar:
      case DateInputMethodKinds.Ad:
      case DateInputMethodKinds.Jp:
      case DateInputMethodKinds.JpHeisei:
        return source.value.isTime
          ? this._configuration.time
          : this._configuration.date;
      case DateInputMethodKinds.HisInfoSelect:
      case DateInputMethodKinds.None:                 // NoneになるのはHIS項目以外ありえないので.変更ある場合は要注意.
        return this._configuration.hisInformation;
      case DateInputMethodKinds.UserDefinitionSelect:
        return this._configuration.userDefinition;
      default:
        return this._configuration.default;
    }
  }

  public readTextStyle(source: DateItem, shouldInputFree: boolean, isFocused: boolean): TextStyle {
    if (source.shouldInputFree || (source.isFreeInputable && shouldInputFree)) {
      return isFocused
        ? this.toFreeInputTextStyle(source)
        : this.toTextStyle(source);
    } else if (source.isEmpty && source.inputMethodKind !== DateInputMethodKinds.Calendar) {
      switch (source.inputMethodOptionKind) {
        case DateInputMethodOptionKinds.Normal:
        case DateInputMethodOptionKinds.Link:
            return this.toTextStyle(source);
        case DateInputMethodOptionKinds.Calculate:
          return this.toErrorTextStyle(source);
        case DateInputMethodOptionKinds.HisItem:
        case DateInputMethodOptionKinds.HisInfoSelect:
        case DateInputMethodOptionKinds.UserDefinition:
        case DateInputMethodOptionKinds.HisFreeInput:
          return this.toObjectNameTextStyle(source);
      }
    }
    return this.toTextStyle(source);
  }

  protected readForegroundDisplayConfiguration(): IEnableConfiguration {
    return this._configuration.foreground;
  }
}
